import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-circle-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 7.5, fill: "currentColor", fillRule: "evenodd", opacity: 0.1 }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M5.75 8.75 7.5 10.5 11 6" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
